import { FormContextConsumer } from '#/components/Form/FormContext';

import { AddressFormContainerInternal } from './AddressFormContainerInternal';

// TODO: Fix this the next time the file is edited.
// oxlint-disable-next-line typescript/no-explicit-any
export function AddressFieldsContainer(props: Record<string, any>) {
  const addressKey =
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    props.index !== undefined ? `addresses.${props.index}` : 'address';
  return (
    <FormContextConsumer>
      {({
        clearErrors,
        updateValueWith,
        fetchingAddress,
        setFetchingAddress,
        errors,
        getValue,
      }) => (
        <AddressFormContainerInternal
          // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'Address ... Remove this comment to see the full error message
          address={getValue(addressKey)}
          fetchingAddress={fetchingAddress}
          setFetchingAddress={setFetchingAddress}
          updateAddress={(update) => {
            updateValueWith(addressKey, (a) => ({ ...a, ...update }));
          }}
          clearErrors={clearErrors}
          error={errors[addressKey]}
          errors={errors}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      )}
    </FormContextConsumer>
  );
}
